import { Bar } from "react-chartjs-2";
import { Chart, ChartData, Legend, Title, Tooltip as ChartJsTooltip, CategoryScale, LinearScale, BarElement, Colors, BarController } from 'chart.js';
import { useEffect, useState } from "react";
import { DeckState } from "../../models/Deck";

Chart.register(
    ChartJsTooltip,
    Title,
    CategoryScale,
    LinearScale,
    Colors,
    BarController,
    CategoryScale,
    LinearScale,
    BarElement,
    Legend
);

export type CostChartProps = {
    deckState: DeckState
}

const getDefaultCostChartState: (data?: number[]) => ChartData<"bar", number[], string> = (data?: number[]) => {
    return {
        datasets: [
            {
                data: data ?? [0]
            }
        ],
        labels: [
            "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"
        ]
    };
}

const defaultCostChartData: ChartData<"bar", number[], string> = {
    labels: ['No Data'],
    datasets: [
        {
            data: [0],
            backgroundColor: ['lightgray']
        },
    ],
};

export function CostChart(props: CostChartProps) {
    const [costChartData, setCostChartData] = useState<ChartData<"bar", number[], string>>(getDefaultCostChartState());
    
    useEffect(() => {
        setCostChartData(getDefaultCostChartState([
            props.deckState.totalCardsByCost[1] ?? 0,
            props.deckState.totalCardsByCost[2] ?? 0,
            props.deckState.totalCardsByCost[3] ?? 0,
            props.deckState.totalCardsByCost[4] ?? 0,
            props.deckState.totalCardsByCost[5] ?? 0,
            props.deckState.totalCardsByCost[6] ?? 0,
            props.deckState.totalCardsByCost[7] ?? 0,
            props.deckState.totalCardsByCost[8] ?? 0,
            props.deckState.totalCardsByCost[9] ?? 0,
            props.deckState.totalCardsByCost[10] ?? 0,
            props.deckState.totalCardsByCost[11] ?? 0
        ]));
    }, [props.deckState]);

    return (
        <div className="justify-center flex max-h-[165px]">
            <Bar
                itemID="costChart"
                options={{
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                        title: {
                            display: true,
                            text: "Cost Distribution",
                            color: "gray"
                        },
                        legend: {
                            display: false
                        }
                    },
                    scales: {
                        y: {

                            ticks: {
                                stepSize: 1
                            }
                        }
                    }
                }}
                data={props.deckState.totalCards ? costChartData : defaultCostChartData} />
        </div>
    )
}